import { useQuery } from '@tanstack/react-query';
import { create as createStore } from 'zustand';

import { sdk } from '@/services';

const AcademyService = sdk.getService('AcademyService');

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 10;

interface IStore {
  page: number;
  limit: number;
  setPageAndLimit: (page: number, limit: number) => void;
}

const store = createStore<IStore>(set => ({
  page: INITIAL_PAGE,
  limit: INITIAL_LIMIT,
  setPageAndLimit: (page: number, limit: number) => set(state => ({ ...state, page, limit }))
}));

export const useAcademiesList = () => {
  const { page, limit, setPageAndLimit } = store();
  const queryKey = ['academies', `page-${page}`, `limit-${limit}`];
  const { isLoading, data, error } = useQuery({
    queryKey,
    queryFn: () => AcademyService.getAcademies({ page, limit })
  });

  const pagination = data && {
    page: data.page,
    limit: data.limit,
    hasNextPage: data.hasNextPage,
    hasPrevPage: data.hasPrevPage,
    nextPage: data.nextPage,
    pagingCounter: data.pagingCounter,
    prevPage: data.prevPage,
    totalDocs: data.totalDocs,
    totalPages: data.totalPages
  };

  return {
    academies: data?.docs || [],
    isLoading,
    error,
    pagination,
    setPageAndLimit
  };
};
